import Page from '@/components/Page'

const Placeholder = ({ title }) => {
  return (
    <Page title={title} />
  )
}

export default Placeholder
